//import { stat } from 'original-fs';
import Vue from 'vue'
import Vuex from 'vuex'

import {Auth} from 'aws-amplify'

Vue.use(Vuex)


const vm = new Vue();

const connectWS = (url) => {
  vm.$connect(url);
};
const disconnectWS = () => {
  vm.$disconnect();
};
const sendMessageWS = (data) => {
  if (!Vue.prototype.$socket) {
    return;
  }
  Vue.prototype.$socket.send(JSON.stringify(data));
};

export default new Vuex.Store({
  state: {
    loginoutchange:0,
    socket: {
      isConnected: false,
      data: null,
    },
    wsUps: 0,
    listchange: 0,
    proMode:true,
    bigMode:false,
    user: {},
    fileItems:[
      { title: 'Home', route: 'Home' }
    ],
    userInfo:{},
    userQAStatuses:{},
    facilityName: "",
    clientName: "",
    facility:"all",
    client:"",
    facilitiesArr:[],
    facilities:{},
    facDocs:[],
    clicked: false,
    statuses: [],
    timeToExport:"00h:00m:00s",
    cdownfunc:null,
    activeEncId:null,
    activeEncStatus:"",
    outgoingEncStatus:"",
    managerOverride:false,
    readOnlyAE:false,
    encounters: {
    },
    encountersUpdatedInit: 0,
    posMap23:{
      "default": [
        "New",
        "Established",
        "Critical Care",
        "Initial Day",
        "Initial and Discharge same day",
        "Subsequent Day",
        "Discharge Day",
        "Consultation"
       ],
      "21": ["Initial Day",
          "Initial and Discharge same day",
          "Subsequent Day",
          "Discharge Day",
          "Critical Care",
          "Consultation",
          "Prolonged Services"],
      "22": ["Initial Day",
          "Initial and Discharge same day",
          "Subsequent Day",
          "Discharge Day",
          "Critical Care",
          "Consultation",
          "Prolonged Services"],
      "11": ["New Patient",
          "Established Patient",
          "Critical Care",
          "Consultation",
          "Prolonged Services"],
      "20": ["New Patient",
          "Established Patient",
          "Critical Care",
          "Consultation",
          "Prolonged Services"]
  },
    calcLogic23: {
      "11": {
       "Consultation": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99245",
         "time": 55
        },
        "low": {
         "level": "99243",
         "time": 30
        },
        "moderate": {
         "level": "99244",
         "time": 40
        },
        "second_em": {
         "level": "99417",
         "trigger": "99245"
        },
        "straightforward": {
         "level": "99242",
         "time": 20
        },
        "time_required": true
       },
       "Critical Care": {
        "standard_timecalc": true,
        "timecalc": {
         "time_0": "99291"
        },
        "time_required": false,
        "time_wins": true
       },
       "Established": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99215",
         "time": 40
        },
        "low": {
         "level": "99213",
         "time": 20
        },
        "moderate": {
         "level": "99214",
         "time": 30
        },
        "nurse_only": "99211",
        "second_em": {
         "divisor": 15,
         "level": "99417",
         "min_time": 55,
         "trigger": "99215"
        },
        "straightforward": {
         "level": "99212",
         "time": 10
        },
        "time_required": true
       },
       "New": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99205",
         "time": 60
        },
        "low": {
         "level": "99203",
         "time": 30
        },
        "moderate": {
         "level": "99204",
         "time": 45
        },
        "second_em": {
         "divisor": 15,
         "level": "99417",
         "min_time": 75,
         "trigger": "99205"
        },
        "straightforward": {
         "level": "99202",
         "time": 25
        },
        "time_required": true
       }
      },
      "20": {
       "Consultation": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99245",
         "time": 55
        },
        "low": {
         "level": "99243",
         "time": 30
        },
        "moderate": {
         "level": "99244",
         "time": 40
        },
        "second_em": {
         "divisor": 15,
         "level": "99417",
         "min_time": 75,
         "trigger": "99205"
        },
        "straightforward": {
         "level": "99242",
         "time": 20
        },
        "time_required": true
       },
       "Critical Care": {
        "standard_timecalc": true,
        "timecalc": {
         "time_0": "99291"
        },
        "time_required": false,
        "time_wins": true
       },
       "Established": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99215",
         "time": 40
        },
        "low": {
         "level": "99213",
         "time": 20
        },
        "moderate": {
         "level": "99214",
         "time": 30
        },
        "nurse_only": "99211",
        "second_em": {
         "divisor": 15,
         "level": "99417",
         "min_time": 75,
         "trigger": "99205"
        },
        "straightforward": {
         "level": "99212",
         "time": 10
        },
        "time_required": true
       },
       "New": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99205",
         "time": 60
        },
        "low": {
         "level": "99203",
         "time": 30
        },
        "moderate": {
         "level": "99204",
         "time": 45
        },
        "second_em": {
         "divisor": 15,
         "level": "99417",
         "min_time": 75,
         "trigger": "99205"
        },
        "straightforward": {
         "level": "99202",
         "time": 15
        },
        "time_required": true
       }
      },
      "21": {
       "Consultation": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99255",
         "time": 80
        },
        "low": {
         "level": "99253",
         "time": 45
        },
        "moderate": {
         "level": "99254",
         "time": 60
        },
        "second_em": {
         "level": "99255",
         "trigger": "99223"
        },
        "straightforward": {
         "level": "99252",
         "time": 35
        },
        "time_required": true
       },
       "Critical Care": {
        "standard_timecalc": true,
        "timecalc": {
         "time_0": "99291"
        },
        "time_required": false,
        "time_wins": true
       },
       "Discharge Day": {
        "timecalc": {
         "time_0": "99238",
         "time_30": "99239"
        },
        "time_required": false,
        "time_wins": true
       },
       "Initial and Discharge same day": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99236",
         "time": 85
        },
        "low": {
         "level": "99234",
         "time": 45
        },
        "moderate": {
         "level": "99235",
         "time": 70
        },
        "second_em": {
         "level": "99418",
         "trigger": "99236"
        },
        "straightforward": {
         "level": "99234",
         "time": 45
        },
        "time_required": true
       },
       "Initial Day": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99223",
         "time": 75
        },
        "low": {
         "level": "99221",
         "time": 40
        },
        "moderate": {
         "level": "99222",
         "time": 55
        },
        "second_em": {
         "level": "99418",
         "trigger": "99223"
        },
        "straightforward": {
         "level": "99221",
         "time": 40
        },
        "time_required": true
       },
       "Subsequent Day": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99233",
         "time": 50
        },
        "low": {
         "level": "99231",
         "time": 25
        },
        "moderate": {
         "level": "99232",
         "time": 35
        },
        "second_em": {
         "level": "99418",
         "trigger": "99233"
        },
        "straightforward": {
         "level": "99231",
         "time": 25
        },
        "time_required": true
       }
      },
      "22": {
       "Consultation": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99255",
         "time": 80
        },
        "low": {
         "level": "99253",
         "time": 45
        },
        "moderate": {
         "level": "99254",
         "time": 60
        },
        "second_em": {
         "level": "99418",
         "trigger": "99255"
        },
        "straightforward": {
         "level": "99252",
         "time": 35
        },
        "time_required": true
       },
       "Critical Care": {
        "standard_timecalc": true,
        "timecalc": {
         "time_0": "99291"
        },
        "time_required": false,
        "time_wins": true
       },
       "Discharge Day": {
        "timecalc": {
         "time_0": "99238",
         "time_30": "99239"
        },
        "time_required": false,
        "time_wins": true
       },
       "Initial and Discharge same day": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99236",
         "time": 85
        },
        "low": {
         "level": "99234",
         "time": 45
        },
        "moderate": {
         "level": "99235",
         "time": 70
        },
        "second_em": {
         "level": "99418",
         "trigger": "99236"
        },
        "straightforward": {
         "level": "99234",
         "time": 45
        },
        "time_required": true
       },
       "Initial Day": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99223",
         "time": 75
        },
        "low": {
         "level": "99221",
         "time": 40
        },
        "moderate": {
         "level": "99222",
         "time": 55
        },
        "second_em": {
         "level": "99418",
         "trigger": "99223"
        },
        "straightforward": {
         "level": "99221",
         "time": 40
        },
        "time_required": true
       },
       "Subsequent Day": {
        "default": {
         "level": "No E&M",
         "time": 0
        },
        "high": {
         "level": "99233",
         "time": 50
        },
        "low": {
         "level": "99231",
         "time": 25
        },
        "moderate": {
         "level": "99232",
         "time": 35
        },
        "second_em": {
         "level": "99418",
         "trigger": "99233"
        },
        "straightforward": {
         "level": "99231",
         "time": 25
        },
        "time_required": true
       }
      },
      "23": {
       "any": {
        "default": "99281",
        "high": "99285",
        "low": "99283",
        "moderate": "99284",
        "standard_timecalc": true,
        "straightforward": "99282",
        "timecalc": {
         "time_0": "99291"
        },
        "time_required": false,
        "time_wins": true
       }
      }
     },
    emToolProLT23:{
      "charta": [
        "None",
        "Straightforward",
        "Low",
        "Moderate",
        "High"
       ],
       "chartb": [
        "None",
        "Straightforward",
        "Low",
        "Moderate",
        "High"
       ],
       "chartc": [
        "None",
        "Straightforward",
        "Low",
        "Moderate",
        "High"
       ],
       "patient_types": [
        "New",
        "Established"
       ],
       "time": {
        "ama": {
         "established": [
          "0",
          "10-19",
          "20-29",
          "30-39",
          "40-54",
          "55-69",
          "70-84",
          "85-99",
          ">99"
         ],
         "new": [
          "<15",
          "15-29",
          "30-44",
          "45-59",
          "60-74",
          "75-89",
          "90-104",
          "105-119",
          ">119"
         ]
        },
        "cms": {
         "established": [
          "0",
          "10-19",
          "20-29",
          "30-39",
          "40-54",
          "55-69",
          "69-83",
          "84-98",
          "99-113"
         ],
         "new": [
          "Less than 15",
          "15-29",
          "30-44",
          "45-59",
          "60-74",
          "75-89",
          "89-103",
          "104-118",
          "119-133"
         ]
        }
       }
    },
    emToolProLT:{
      history:[
       "No History",
       "Problem-Focused",
       "Expanded Problem-Focused",
       "Detailed",
       "Comprehensive"
      ],
      exam:[
        "No Exam",
        "Problem-Focused",
        "Expanded Problem-Focused",
        "Detailed",
        "Comprehensive"
      ],
      mdm:[
        "No MDM",
        "Straightforward",
        "Low",
        "Low-Moderate",
        "High-Moderate",
        "High"
      ],
      time:[
        "Less than 30 minutes",
        "30-74 minutes",
        "75-104 minutes",
        "105-134 minutes",
        "135-164 minutes",
        "165-194 minutes",
        "195 or longer"
      ]
    },
    origEncounters: {
    },
    encPDF: "",
    facSettings:{
      statuses:[],
    },
    acepToolChoices:[],
    allCodes:{
      EM:[],
      CPT:[]
    },
    allMods:{
      EM:[],
      CPT:[],
      INI:[]
    },
    dxs:[],
    hcpcss:[],
    providers:[],
    drugs:[],
    iniRXSimple:[],
    mipsMeasures:[],
    appSettings: {
      statuses: [
        "NEW", 
        "IN PROGRESS", 
        "INCOMPLETE", 
        "DEFICIENT", 
        //"WAITING", 
        "UPDATED", 
        "QA", 
        "COMPLETE", 
        "EXPORT"],
      queueStatusCols: [{
        value: "new",
        status: "NEW",
        text: "New",
        field: "new",
        title: "New",
        align: "center"
      },{
        value: "updated",
        status: "UPDATED",
        text: "Updated",
        field: "updated",
        title: "Updated",
        align: "center"
      }, {
        value: "in_progress",
        status: "IN PROGRESS",
        text: "In Progress",
        field: "in_progress",
        title: "In Progress",
        align: "center"
      }, {
        value: "incomplete",
        status: "INCOMPLETE",
        text: "Incomplete",
        field: "incomplete",
        title: "Incomplete",
        align: "center"
      }, {
        value: "qa",
        status: "QA",
        text: "QA",
        field: "qa",
        title: "QA",
        align: "center"
      }, {
        value: "complete",
        status: "COMPLETE",
        text: "Complete",
        field: "complete",
        title: "Complete",
        align: "center"
      },  {
        value: "deficient",
        status: "DEFICIENT",
        text: "Deficient",
        field: "deficient",
        title: "Deficient",
        align: "center"
      },
      // {
      //   value: "waiting",
      //   status: "WAITING",
      //   text: "Waiting",
      //   field: "waiting",
      //   title: "Waiting",
      //   align: "center"
      // },
      {
        value: "export",
        status: "EXPORT",
        text: "Export",
        field: "export",
        title: "Export",
        align: "center"
      }],
      queueStatusTable: [
      {
        field: "new",
        title: "New",
      }, {
        field: "in_progress",
        title: "In Progress",
      }, {
        field: "incomplete",
        title: "Incomplete",
      }, {
        field: "qa",
        title: "QA",
      },{
        field: "complete",
        title: "Complete",
      },  {
        field: "deficient",
        title: "Deficient",
      },{
        field: "export",
        title: "Export",
      }]
    },
  },
  getters: {
    jwt: state => {
      return state.user.signInUserSession.accessToken.jwtToken;
    },
    loginoutchange: (state) => {
      return state.loginoutchange;
    },
    wsUps: (state) => {
      return state.wsUps;
    },
    listchange: (state) => {
      return state.listchange;
    },
    proMode: state => {
      return state.proMode;
    },
    bigMode: state => {
      return state.bigMode;
    },
    username: state => {
      return state.user.username;
    },
    userid: state => {
      return state.user.attributes.sub;
    },
    userprof: state => {
      return state.userInfo.profile;
    },
    qaToReview: state => {
      return state.userInfo.qa_to_review;
    },
    userQAStatuses: state => {
      return state.userQAStatuses;
    },
    timeToExport: state => {
      return state.timeToExport;
    },
    fileItems: state => {
      return state.fileItems;
    },
    facilitiesArr: state => {
      return state.facilitiesArr;
    },
    facilities: state => {
      return state.facilities;
    },
    facDocs: state => {
      return state.facDocs;
    },
    facility: state => {
      return state.facility;
    },
    client: state => {
      return state.client;
    },
    facilityName: state => {
      return state.facilityName;
    },
    clientName: state => {
      return state.clientName;
    },
    statuses: state => {
      return state.statuses;
    },
    facStatuses: state => {
      return state.facSettings.statuses;
    },
    facCTypes: state => {
      return state.facSettings.charge_types;
    },
    noCalc: state => {
      return state.facSettings.no_calc;
    },
    demoEdit: state => {
      return state.facSettings.demo_edit;
    },
    auditFac: state => {
      return (state.facSettings.audit_only ? state.facSettings.audit_only : false);
    },
    sortStatuses: state => {
      return ["",...state.facSettings.statuses,{divider:true},"My QA Reviewed"];
    },
    emToolProLT: state => {
      return state.emToolProLT;
    },
    emToolProLT23: state => {
      return state.emToolProLT23;
    },
    posMap23: state => {
      return state.posMap23;
    },
    calcLogic23: state => {
      return state.calcLogic23;
    },
    clicked: state => {
      return state.clicked;
    },
    activeEncId: state => {
      return state.activeEncId;
    },
    activeEncStatus: state => {
      return state.activeEncStatus;
    },
    outgoingEncStatus: state => {
      return state.outgoingEncStatus;
    },
    readOnlyAE: state => {
      return state.readOnlyAE;
    },
    managerOverride: state => {
      return state.managerOverride;
    },
    overallStatusCount: state => {
      let statusesarr = state.statuses,
          statuslist = state.appSettings.statuses,
          statusCount = {open:0,complete:0,total:0,perComplete:0};
      if(state.facility == "all"){
        for(let s=0; s<statusesarr.length; s++){
          let statuses = statusesarr[s],
              statKeys = Object.keys(statuses);
          for(let k=0; k<statKeys.length; k++){
            //// console.log(statKeys[k] + " - " + statuses[statKeys[k]]);
            // if(statKeys[k] == "complete" || statKeys[k] == "export"){
            if(statKeys[k] == "complete"){
              statusCount.complete += statuses[statKeys[k]];
            }else if(statKeys[k] == "export"){
              
            }else if(statuslist.includes(statKeys[k].toUpperCase()) || statKeys[k] == "in_progress" || statKeys[k] == "deficient" ){
              statusCount.open += statuses[statKeys[k]];
            }
          }
        }
      }else{
        for(let s=0; s<statusesarr.length; s++){
          if(statusesarr[s].facility == state.facility){
            let statuses = statusesarr[s],
                statKeys = Object.keys(statuses);
            for(let k=0; k<statKeys.length; k++){
              //// console.log(statKeys[k] + " - " + statuses[statKeys[k]]);
              // if(statKeys[k] == "complete" || statKeys[k] == "export"){
              if(statKeys[k] == "complete"){
                statusCount.complete += statuses[statKeys[k]];
              }else if(statKeys[k] == "export"){
              
              }else if(statuslist.includes(statKeys[k].toUpperCase()) || statKeys[k] == "in_progress" || statKeys[k] == "deficient" ){
                statusCount.open += statuses[statKeys[k]];
              }
            }
          }
        }
      }
      
      statusCount.total = statusCount.complete + statusCount.open;
      statusCount.perComplete = (statusCount.complete/statusCount.total)*100
      //// console.log(statusCount);
      return statusCount;
    },
    encountersUpdatedInit: state => {
      return state.encountersUpdatedInit;
    },
    encs: state => {
      return state.encounters;
    },
    encsFac: state => (fac) => {
      return state.encounters[fac];
    },
    origEncs: state => {
      return state.origEncounters;
    },
    QueueStatusCols: state => {
      return state.appSettings.queueStatusCols;
    },
    QueueStatusTable: state => {
      return state.appSettings.queueStatusTable;
    },
    encStatuses: state => {
      return state.appSettings.statuses;
    },
    encPDF: state => {
      return state.encPDF;
    },
    acepToolChoices: state => {
      return state.acepToolChoices;
    },
    emCodes: state => {
      return [{text:"",value:""},{text:"No E&M",value:"No E&M"},...state.allCodes.PRO.EM,...state.allCodes.TECH.EM];
    },
    cptCodes: state => {
      return [{text:"",value:""},...state.allCodes.PRO.CPT,...state.allCodes.TECH.CPT];
    },
    emProCodes: state => {
      let codes = (state.allCodes.PRO ? state.allCodes.PRO.EM : [{}]);
      return [{text:"",value:""},{text:"No E&M",value:"No E&M"},...codes];
    },
    cptProCodes: state => {
      let codes = (state.allCodes.PRO ? state.allCodes.PRO.CPT : [{}]);
      return [{text:"",value:""},...codes];
    },
    emTechCodes: state => {
      let codes = (state.allCodes.TECH ? state.allCodes.TECH.EM : [{}]);
      return [{text:"",value:""},{text:"No E&M",value:"No E&M"},...codes];
    },
    cptTechCodes: state => {
      let codes = (state.allCodes.PRO ? state.allCodes.TECH.CPT : [{}]);
      return [{text:"",value:""},...codes];
    },
    emMods: state => {
      return state.allMods.EM;
    },
    cptMods: state => {
      return state.allMods.CPT;
    },
    iniMods: state => {
      return state.allMods.INI;
    },
    dxs: state => {
      return state.dxs;
    },
    hcpcss: state => {
      return state.hcpcss;
    },
    drugs: state => {
      return state.drugs;
    },
    Providers: state => {
      return [{displayName:"",clientid:""},...state.providers];
    },
    facSettings: state => {
      return state.facSettings;
    },
    facCodeTypes: state => {
      return state.facSettings.code_types;
    },
    facWorksheets: state => {
      return (state.facSettings.worksheets ? state.facSettings.worksheets : []);
    },
    facTools: state => {
      return state.facSettings.tools;
    },
    multiEms: state => {
      return state.facSettings.multi_ems;
    },
    facDepts: state => (type) => {
      let out = "ER";
      if(state.facSettings && state.facSettings.fac_type){
        for (let f=0; f<state.facSettings.fac_type.length; f++){
          if(state.facSettings.fac_type[f].type == type){
            out = state.facSettings.fac_type[f].dept;
            break;
          }
        }
      }
      return out;
    },
    cdiReasons: state =>{
      let cdiRaw = state.facSettings.cdi_reasons, cdiOut=[], dcRaw = state.facSettings.downcode_reasons, dcOut=[];
      for (let f=0; f<cdiRaw.length; f++){
        cdiOut.push(cdiRaw[f].label);
      }
      for (let d=0; d<dcRaw.length; d++){
        dcOut.push(dcRaw[d].label);
      }
      // return ["",...cdiOut,...dcOut,"Other CDI"];
      return ["",...cdiOut,"Other CDI"];
    },
    downcodeReasons: state =>{
      let dcRaw = state.facSettings.downcode_reasons, dcOut=[];
      for (let d=0; d<dcRaw.length; d++){
        dcOut.push(dcRaw[d].label);
      }
      return ["",...dcOut,"Other Downcode"];
    },
    deficientReasons: state =>{
      let susRaw = state.facSettings.deficient_reasons, susOut=[];
      for (let f=0; f<susRaw.length; f++){
        susOut.push(susRaw[f].label);
      }
      return susOut;
    },
    noteTypes: state =>{
      let typesRaw = state.facSettings.note_types, typesOut=[];
      for (let f=0; f<typesRaw.length; f++){
        typesOut.push(typesRaw[f].label);
      }
      return typesOut;
    },
    requiredFields: state => {
      return state.facSettings.required_fields;
    },
    iniRXSimple: state =>{
      return state.iniRXSimple;
    },
    mipsMeasures: state =>{
      return state.mipsMeasures;
    },
    departments: state =>{
      let depsRaw = state.facSettings.departments, depsOut=[];
      for (let f=0; f<depsRaw.length; f++){
        depsOut.push(depsRaw[f].label);
      }
      return depsOut;
    },
    ivSites: state =>{
      let sitesRaw = state.facSettings.iv_sites, sitesOut=[];
      for (let f=0; f<sitesRaw.length; f++){
        sitesOut.push(sitesRaw[f].label);
      }
      return sitesOut;
    },
    infType: state =>{
      let infTypeRaw = state.facSettings.inf_type, infTypeOut=[];
      for (let f=0; f<infTypeRaw.length; f++){
        infTypeOut.push(infTypeRaw[f].label);
      }
      return infTypeOut;
    },
    injType: state =>{
      let injTypeRaw = state.facSettings.inj_type, injTypeOut=[];
      for (let f=0; f<injTypeRaw.length; f++){
        injTypeOut.push(injTypeRaw[f].label);
      }
      return injTypeOut;
    },
    infIvpRule: state => {
      return state.facSettings.ini_settings.inf_ivp_rule;
    },
    infSameSyrRule: state => {
      return state.facSettings.ini_settings.same_syringe_override;
    },
    infDispFixed: state => {
      return state.facSettings.ini_settings.display_fixed;
    },
    obsExclusionReasons: state =>{
      return state.facSettings.exclusionReasons
    },
    obsArrivalSources: state =>{
      return state.facSettings.arrivalSources
    },
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      if (!state.socket.isConnected) {
        //Vue.prototype.$socket = event.currentTarget;
        state.socket.isConnected = true;
        //sendMessageWS({action:"PING"});
      }
      // console.log("WS CONNECTED: " + state.socket.isConnected);
    },
    SOCKET_ONCLOSE(state, event) {
      // console.log("SOCKET_ONCLOSE", state, event);
      state.socket.isConnected = false;
      Vue.prototype.$socket = null;
    },
    SOCKET_ONMESSAGE(state, message) {
      // console.log("INCOMING: " + JSON.stringify(message));
      if (message.encid && message.facility == state.facSettings.facility) {
        const encIndex = state.encounters[message.facility].findIndex(
          (enc) => enc.encid == message.encid
        );
        // console.log("ENC IND: " + encIndex);
        let encOld = { ...state.encounters[message.facility][encIndex] };
        //// console.log("OLD: " + JSON.stringify(encOld));
        //if(true){

        // if(encOld.encid != state.activeEncId || state.readOnlyAE){
          if(message.encid == state.activeEncId){
            if(message.user != state.user.username && !state.readOnlyAE){
              if(message.status == "IN PROGRESS" || message.status == "COMPLETE"){
                // console.log("MANAGER OVERRIDE!");
                state.managerOverride = true;
              }else{
                //state.managerOverride = false;
              }
            }
            state.activeEncStatus = message.status;
          }
          
          encOld.status = message.status;
          state.encounters[message.facility][encIndex] = encOld;

          let statusData = statusCleaner(
            state.encounters[message.facility],
            this.getters.QueueStatusCols,
          );
          const statIndex = state.statuses.findIndex(
            (st) => st.facility == message.facility
          );
          //// console.log("STAT BEFORE: " + JSON.stringify(state.statuses));
          //// console.log("STAT AFTER: " + JSON.stringify(statusData));
          state.statuses[statIndex] = statusData[0];
        // }else if(message.status == "IN PROGRESS"){
        //   // console.log("MANAGER OVERRIDE!");

        // }else if(message.status == "EXPORT"){
        //   // console.log("EXPORTED!");

        // }else{
        //   // console.log("IN PROGRESS ALREADY, DON'T CHANGE!");

        // }

        if(message.noteChange){
          // console.log("NOTE CHANGE")
          encOld.notes = message.notes;
          state.encounters[message.facility][encIndex] = encOld;
          
          // let statusData = statusCleaner(
          //   state.encounters[message.facility],
          //   this.getters.QueueStatusCols,
          // );
          // const statIndex = state.statuses.findIndex(
          //   (st) => st.facility == message.facility
          // );
          // state.statuses[statIndex] = statusData[0];
        }

        const oEncIndex = state.origEncounters[message.facility].findIndex(
          (enc) => enc.encid == message.encid
        );
        let oEncOld = { ...state.origEncounters[message.facility][oEncIndex] };
        //// console.log("OLD: " + JSON.stringify(oEncOld));

        //if(oEncOld.encid != state.activeEncId || state.readOnlyAE){
          oEncOld.status = message.status;
          state.origEncounters[message.facility][oEncIndex] = oEncOld;

          // let statusData = statusCleaner(
          //   state.origEncounters[message.facility],
          //   this.getters.QueueStatusCols,
          // );
        // }else{
        //   // console.log("IN PROGRESS ALREADY, DON'T CHANGE!")
        // }

        if(message.noteChange){
          oEncOld.notes = message.notes;
          state.origEncounters[message.facility][oEncIndex] = oEncOld;

          // let statusData = statusCleaner(
          //   state.origEncounters[message.facility],
          //   this.getters.QueueStatusCols,
          // );
        }
        state.wsUps++;
        state.listchange++;
      }else{
        // console.log("NOT MY FACILITY");
      }
      
    },
    addWSUP(state) {
      state.wsUps++;
    },
    addloginoutchange(state){
      state.loginoutchange++;
    },
    addLISTCHANGE(state) {
      state.listchange++;
    },
    updateUser(state, newuser) {
      state.user = newuser;
    },
    updateTimeToExport(state, newtime) {
      state.timeToExport = newtime;
    },
    updateProMode(state, newmode) {
      state.proMode = newmode;
    },
    updateBigMode(state, newmode) {
      state.bigMode = newmode;
    },
    updateUserInfo(state, newinfo) {
      state.userInfo = newinfo;
      if(Object.keys(newinfo).indexOf("proMode") != -1){
        state.proMode = newinfo.proMode;
      }
      if(Object.keys(newinfo).indexOf("bigMode") != -1){
        state.bigMode = newinfo.bigMode;
      }
    },
    updateUserQAStatuses(state, newstatuses){
      state.userQAStatuses = newstatuses;
    },
    updateClientName(state, newclient) {
      state.clientName = newclient;
    },
    updateFac(state, newfac) {
      state.facility = newfac;
    },
    updateClient(state, newclient) {
      state.client = newclient;
    },
    updateFacility(state, newfac) {
      state.facilityName = newfac;
    },
    updateClicked(state, newclick) {
      state.clicked = newclick;
    },
    updateActiveEncId(state, newid) {
      state.activeEncId = newid;
    },
    updateActiveEncStatus(state, status) {
      state.activeEncStatus = status;
    },
    updateOutgoingEncStatus(state, status) {
      state.outgoingEncStatus = status;
    },
    updateManagerOverride(state, status) {
      state.managerOverride = status;
    },
    updateReadOnlyAE(state, newbool) {
      state.readOnlyAE = newbool;
    },
    updateEncountersUpdatedInit(state) {
      state.encountersUpdatedInit++;
    },
    updateFacilityNames(state, newfacilityNames) {
      state.facilityNames = newfacilityNames;
    },
    updateProviders(state, newprovs) {
      state.providers = newprovs;
    },
    updateFacilitiesArr(state, newfacilities) {
      state.facilitiesArr = newfacilities;
    },
    updateFileItems(state, items) {
      state.fileItems = [...new Set(state.fileItems),...new Set(items)];
    },
    updateFacilities(state, newfacilities) {
      state.facilities = newfacilities;
    },
    updateFacDocs(state, newfacdocs) {
      state.facDocs = newfacdocs;
    },
    updateEncounters(state, {newencs, fac}) {
      //// console.log("UPDATING " + fac);
      //// console.log("WITH " + newencs.length);
      state.encounters[fac] = newencs;
      state.origEncounters[fac] = newencs;
      state.wsUps++;
      state.listchange++;
    },
    updateEncountersInit(state, initencs) {
      state.encounters = initencs;
      state.origEncounters = initencs;
      state.wsUps++;
      state.listchange++;
    },
    updateStatuses(state, newstatuses) {
      //// console.log(JSON.stringify(newstatuses));
      //state.statuses.push(newstatuses[0]);
      state.statuses = newstatuses;
    },
    updateEncPDF(state, newpdf) {
      state.encPDF = newpdf;
    },
    updateCodes(state, newcodes) {
      state.allCodes = newcodes;
    },
    updateMods(state, newmods) {
      state.allMods = newmods;
    },
    updateACEPTool(state, newdata) {
      state.acepToolChoices = newdata.sort((a, b) => a.order - b.order);
    },
    updateEMTool(state, newdata) {
      if(newdata.selections){
        state.emToolProLT = newdata.selections;
      }
      if(newdata.selections_2023){
        state.emToolProLT23 = newdata.selections_2023;
      }
      if(newdata.calc_logic){
        state.calcLogic23 = newdata.calc_logic;
      }
      if(newdata.pos_map){
        state.posMap23 = newdata.pos_map;
      }
    },
    updateDXs(state, newdxs) {
      state.dxs = newdxs;
    },
    updateHCPCSs(state, newhcpcss) {
      state.hcpcss = newhcpcss;
    },
    updateInIRXsimple(state, newData) {
      state.iniRXSimple = newData;
    },
    updateMIPs(state, newData) {
      state.mipsMeasures = newData;
    },
    updateFacSettings(state, newSettings) {
      state.facSettings = newSettings;
    },
    updateEncStatuses(state, newencstatuses) {
      state.appSettings.statuses = newencstatuses;
    }
  },
  actions: {
    WSConnect({ commit, state }, url) {
      connectWS(url);
    },
    WSDisconnect({ commit, state }) {
      disconnectWS();
    },
    addWSUP({
      commit
    }, payload) {
      commit("addWSUP");
    },
    addloginoutchange({
      commit
    }, payload) {
      commit("addloginoutchange");
    },
    addLISTCHANGE({
      commit
    }, payload) {
      commit("addLISTCHANGE");
    },
    updateProMode({
      commit
    }, payload) {
      commit("updateProMode", payload);
    },
    updateBigMode({
      commit
    }, payload) {
      commit("updateBigMode", payload);
    },
    updateTimeToExport({
      commit
    }, payload) {
      let x;
      if(payload.export_time){
        // console.log("COUNTDOWN BEGINS");
        // Set the date we're counting down to
        let expH = payload.export_time.split(":")[0], expM = payload.export_time.split(":")[1];
        let utcYear = new Date().getUTCFullYear(), utcMonth = new Date().getUTCMonth()+1, utcDay = new Date().getUTCDate(), utcHour = new Date().getUTCHours(), utcMin = new Date().getUTCMinutes(),
            utcMilli = new Date(utcYear + "-" + (utcMonth<10 ? "0" + utcMonth : utcMonth ) + "-" + utcDay + " " + utcHour + ":" + utcMin).getTime();
        if(expH<utcHour){
          let d = 24*60*60*1000;
          utcMilli = utcMilli+d;
        }
        let utcYearOut = new Date(utcMilli).getUTCFullYear(), utcMonthOut = new Date(utcMilli).getUTCMonth()+1, utcDayOut = new Date(utcMilli).getUTCDate(); 
        let countDownDate = new Date(utcYearOut + "-" + (utcMonthOut<10 ? "0" + utcMonthOut : utcMonthOut ) + "-" + utcDayOut + " " + expH + ":" + expM).getTime();

        // Update the count down every 1 second
        this.state.cdownfunc = setInterval(function() {

          // Get today's date and time
          let utcYearNow = new Date().getUTCFullYear(), utcMonthNow = new Date().getUTCMonth()+1, utcDayNow = new Date().getUTCDate(), utcHourNow = new Date().getUTCHours(), utcMinNow = new Date().getUTCMinutes(), utcSecNow = new Date().getUTCSeconds(),
              utcMilliNow = new Date(utcYearNow + "-" + (utcMonthNow<10 ? "0" + utcMonthNow : utcMonthNow ) + "-" + utcDayNow + " " + utcHourNow + ":" + utcMinNow + ":" + utcSecNow).getTime();
          let now = new Date(utcMilliNow).getTime();
          //// console.log(utcMilliNow);

          // Find the distance between now and the count down date
          let distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          let TTE = (hours<10 ? "0" + hours : hours) + "h:" + (minutes<10 ? "0" + minutes : minutes) + "m:" + (seconds<10 ? "0" + seconds : seconds) + "s";
          //this.$store.dispatch("updateTimeToExport",TTE);
          commit("updateTimeToExport", TTE);
          // If the count down is finished, write some text
          // if (distance < 0) {
          //   clearInterval(x);
          // }
        }, 1000);
      }else{
        commit("updateTimeToExport", "No Set Time");
        clearInterval(this.state.cdownfunc);
      }
    },
    updateUser({
      commit
    }, payload) {
      commit("updateUser", payload);
    },
    updateFacClient({
      commit
    }, payload) {
      commit("updateFacility", payload.facility);
      commit("updateClientName", payload.client);
    },
    updateFac({
      commit
    }, payload) {
      commit("updateFac", payload);
    },
    updateClient({
      commit
    }, payload) {
      commit("updateClient", payload);
    },
    updateClicked({
      commit
    }, payload) {
      commit("updateClicked", payload);
    },
    updateActiveEncId({
      commit
    }, payload) {
      commit("updateActiveEncId", payload);
    },
    updateActiveEncStatus({
      commit
    }, payload) {
      commit("updateActiveEncStatus", payload);
    },
    updateOutgoingEncStatus({
      commit
    }, payload) {
      commit("updateOutgoingEncStatus", payload);
    },
    updateManagerOverride({
      commit
    }, payload) {
      commit("updateManagerOverride", payload);
    },
    updateReadOnlyAE({
      commit
    }, payload) {
      commit("updateReadOnlyAE", payload);
    },
    updateEncountersUpdatedInit({
      commit
    }) {
      commit("updateEncountersUpdatedInit");
    },
    updateFacilityNames({
      commit
    }, payload) {
      if (payload) {
        commit("updateFacilityNames", payload);
      } else {
        commit("updateFacilityNames", ["Test_ProTech"]);
      }
    },
    async updateUserInfo({
      commit
    }, payload) {
      if (payload) {
        commit("updateUserInfo", payload);
      } else {
        //TODO: Update dev/prod based on url
        getData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/v2/users/byid/" + this.getters.userid, this.getters.jwt)
          .then((data) => {
            commit("updateUserInfo", data[0]);
          });
      }
    },
    async updateUserFacilities({
      commit
    }, payload) {
      if (payload) {
        commit("updateUserFacilities", payload);
      } else {
        //TODO: Update dev/prod based on url
        return getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/facility", this.getters.jwt)
          .then((data) => {
            commit("updateFacilitiesArr", data);
            let facout={},items=[{divider:true,route:null}];
            for (let d=0; d<data.length; d++){
              // NOTE: MAY BE NEEDED IF MULTIPLE FACILITIES WITH SAME NAME
              // if(facout[data[d].facility]){
              //   facout[data[d].facility].push(data[d]);
              // }else{
              //   facout[data[d].facility] = [data[d]];
              // }
              items.push({
                title: data[d].facility_display_name, 
                path: '/facility/' +  data[d].facility,
                param: data[d].facility,
                route:'Facility'
              })
              facout[data[d].facility] = data[d];
            }
            commit("updateFileItems",items);
            commit("updateFacilities", facout);
          });
      }
    },
    async updateFacDocs({
      commit
    }, payload) {
        return getData("https://9ins5mn0lg.execute-api.us-east-1.amazonaws.com/v2/fac_docs/" + payload.client + "/" + payload.facility, this.getters.jwt)
        .then((response) => {
          // console.log("DOCS: " + response.length);
          //// console.log(JSON.stringify(response[0]));
          let filesOut = [];
          for (let r=0; r<response.length; r++){
              if(response[r].Size>0){
                  let d = new Date(response[r].LastModified),
                      filename = response[r].Key.split("/").pop(),
                      filetype = filename.split(".").pop();;
                  filesOut.push({
                      filename:filename,
                      sizefix:formatBytes(response[r].Size),
                      uploaded:d.toUTCString(),
                      dockey:filename,
                      filetype:filetype
                  });
              }
          }
          commit("updateFacDocs",filesOut);
      });
    },
    async updateUserQAStatuses({
      commit
    }, payload) {
      if (payload) {
        //TODO: Update dev/prod based on url
        getData("https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/user/" + payload.user + "/qastatuses?count=true", this.getters.jwt)
          .then((data) => {
            commit("updateUserQAStatuses", data);
          });
      }
    },
    async updateStatusesSSR({
      commit,
      dispatch
    }, payload) {
      if (payload) {
        commit("updateStatuses", payload);
      } else {
        //TODO: Update dev/prod based on url
        await dispatch("updateUserFacilities");
        return getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encountersinit/stats", this.getters.jwt)
          .then((data) => {
            // dispatch("updateFacilityNames");
            commit("updateStatuses", data);
            commit("updateEncountersUpdatedInit");
          });
      }
    },
    async updateEncountersInit({
      commit,
      dispatch
    }, payload) {
      if (payload) {
        commit("updateEncountersInit", payload);
      } else {
        //TODO: Update dev/prod based on url
        await dispatch("updateUserFacilities");
        return getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encountersinit/small", this.getters.jwt)
          .then((data) => {
            // dispatch("updateFacilityNames");
            let encout = {}, dlen = data.length;
            for (let d=0; d<dlen; d++){
              if(encout[data[d].facility]){
                encout[data[d].facility].push(data[d]);
              }else{
                encout[data[d].facility] = [data[d]];
              }
            }
            //OK, this is the dumb depth of data binding stuff from vue...
            //if you don't push fac by fac it breaks sorting and probably other things
            let ekeys = Object.keys(encout), elen = ekeys.length;
            for(let e=0; e<elen; e++){
              commit("updateEncounters", {newencs:encout[ekeys[e]],fac:ekeys[e]});
            }
            dispatch("updateStatusesNew", data);
            commit("updateEncountersUpdatedInit");

          });
      }
    },
    async updateEncountersFac({
      commit,
      dispatch
    }, payload) {
      if (payload) {
        commit("updateEncounters", {newencs:payload,fac:this.getters.facility});
      } else {
        //TODO: Update dev/prod based on url
        return getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encountersinit/byfac/" + this.getters.facility, this.getters.jwt)
          .then((data) => {
            commit("updateEncounters", {newencs:data,fac:this.getters.facility});
            commit("updateEncountersUpdatedInit");

          });
      }
    },
    updateEncounters({
      commit,
      dispatch
    }, payload) {
      if (payload) {
        commit("updateEncounters", payload);
      } else {
        //TODO: Update dev/prod based on url
        getData(" https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/WMH", this.getters.jwt)
          .then((data) => {
            //dispatch("updateFacilityNames");
            dispatch("updateStatuses", data);
            commit("updateEncounters", {newencs:data,fac:"WMH"});
          });
      }
    },
    updateEncountersTest({
      commit,
      dispatch
    }, payload) {
      if (payload) {
        commit("updateEncounters", payload);
      } else {
        //TODO: Update dev/prod based on url
        getData(" https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/Test_Fac", this.getters.jwt)
          .then((data) => {
            //dispatch("updateFacilityNames");
            dispatch("updateStatuses", data);
            commit("updateEncounters", {newencs:data,fac:"Test_Fac"});
          });
      }
    },
    updateEncPDF({
      commit
    }, payload) {
      if (payload) {
        //TODO: Update dev/prod based on url
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/docs/" + this.getters.client + "/" + this.getters.facility +"/" +payload, this.getters.jwt)
          .then((data) => {
            commit("updateEncPDF", data.url);
          });
      } else {
        let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
        commit("updateEncPDF", def);
      }
    },
    async updateFacSettings({
      commit,
      dispatch
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        return getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/facility/" + this.getters.client + "/" + this.getters.facility, this.getters.jwt)
          .then((data) => {
            commit("updateFacSettings", data);
            // console.log("FAC LOADED store");
            dispatch("updateTimeToExport",data);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    async updateInIRXsimple({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        return getData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/v2/rxdata/inisimple", this.getters.jwt)
          .then((data) => {
            commit("updateInIRXsimple", data);
          });
          // .then((url) => {
          //   return getData(url.url, this.getters.jwt)
          //     .then((data) => {
          //       commit("updateInIRXsimple", data.json());
          //     });
          // });
    },
    async updateMIPs({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        return getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/mips", this.getters.jwt)
          .then((data) => {
            commit("updateMIPs", data);
          });
    },
    updateProviders({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/providers/" + this.getters.facility, this.getters.jwt)
          .then((data) => {
            commit("updateProviders", data);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    updateCodes({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/codes/WMH_TECH", this.getters.jwt)
          .then((data) => {
            let codeData = codeCleaner(data);
            commit("updateCodes", codeData);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    updateCodesAll({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/codes/facility/" + this.getters.facility, this.getters.jwt)
          .then((data) => {
            let codeData = codeCleanerPT(data);
            commit("updateCodes", codeData);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    updateMods({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/codes/" + this.getters.facility + "/mods", this.getters.jwt)
          .then((data) => {
            //let modData = modCleaner(data);
            let modData = modCleanerSimple(data);
            //// console.log(modData)
            commit("updateMods", modData);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    updateACEPTool({
      commit
    }, payload) {
        //TODO: Update dev/prod based on url AND make variable
        if(this.getters.facTools.indexOf('EM_TOOL_ACEP_LT')!=-1){
          getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/aceptool", this.getters.jwt)
            .then((data) => {
              commit("updateACEPTool", data);
            });
        }
    },
    updateEMTool({
      commit
    }, payload) {
        //TODO: Update dev/prod based on url AND make variable
        if(this.getters.facTools.indexOf('EM_TOOL_PRO_LT')!=-1 || this.getters.facTools.indexOf('EM_CLINIC_TOOL_LT')!=-1){
          let type = this.getters.facDepts("PRO"),
              version = "LT";
          if(type){
            getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/emtool/type/" + type + "?version=" + version, this.getters.jwt)
              .then((data) => {
                commit("updateEMTool", data);
              });
            }
        }
    },
    updateDXs({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/codes/" + this.getters.facility + "/dxs", this.getters.jwt)
          .then((data) => {
            //// console.log(modData)
            commit("updateDXs", data);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    updateHCPCSs({
      commit
    }, payload) {
      //if (payload) {
        //TODO: Update dev/prod based on url AND make variable
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/codes/" + this.getters.facility + "/hcpcss", this.getters.jwt)
          .then((data) => {
            //// console.log(modData)
            commit("updateHCPCSs", data);
          });
      // } else {
      //   let def = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      //   commit("updateEncPDF", def);
      // }
    },
    async updateStatuses({
      commit
    }, payload) {
      // console.log("UPDATE STATUS");
      if (payload) {
        //// console.log(payload[0]);
        let statusData = statusCleaner(payload, this.getters.QueueStatusCols);
        //// console.log("STATUS DATA: " + JSON.stringify(statusData));
        commit("updateStatuses", statusData);
      } else {
        // console.log("NOTHING TO UPDATE");
      }
    },
    async updateStatusesNew({
      commit
    }, payload) {
      // console.log("UPDATE STATUS");
      if (payload) {
        //// console.log(payload[0]);
        let statusData = statusCleanerNew(payload, this.getters.QueueStatusCols, this.getters.facilities);
        // // console.log("STATUS DATA: " + JSON.stringify(statusData));
        commit("updateStatuses", statusData);
      } else {
        // console.log("NOTHING TO UPDATE");
      }
    },
  }
});

const formatBytes = function(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const codeCleanerPT = function(pload){
  let plen = pload.length,
      out = {PRO:{EM:[],CPT:[]},TECH:{EM:[],CPT:[]}};
  for (let p=0; p<plen; p++){
    if(pload[p].active){
      let pt = pload[p].fac_type, cset = pload[p].type;
      if(pt && cset){
        out[pt][cset].push({
          value: pload[p].code,
          text: pload[p].code + " - " + pload[p].description,
        });
      }else{
        // console.log ("DIDN'T FIT: " + pload[p].type);
      }
    }
  }
  return out;
}
const codeCleaner = function(pload){
  let plen = pload.length,
      out = {EM:[],CPT:[]};
  for (let p=0; p<plen; p++){
    if(pload[p].active){
      if(pload[p].type == "EM"){
        out.EM.push({
          value: pload[p].code,
          text: pload[p].code + " - " + pload[p].description,
        })
      }else if(pload[p].type == "CPT"){
        out.CPT.push({
          value: pload[p].code,
          text: pload[p].code + " - " + pload[p].description,
        })
      }else{
        // console.log ("DIDN'T FIT: " + pload[p].type);
      }
    }
  }
  return out;
}
const modCleanerSimple = function(pload){
  let plen = pload.length,
      out = {EM:[],CPT:[],INI:[]};
  for (let p=0; p<plen; p++){
    if(pload[p].type == "EM"){
      out.EM.push(pload[p].mod);
    }else if(pload[p].type == "CPT"){
      out.CPT.push(pload[p].mod)
    }else if(pload[p].type == "INI"){
      out.INI.push(pload[p].mod)
    }else{
      // console.log ("DIDN'T FIT: " + pload[p].type);
    }
  }
  return out;
}
const modCleaner = function(pload){
  let plen = pload.length,
      out = {EM:[],CPT:[]};
  for (let p=0; p<plen; p++){
    if(pload[p].type == "EM"){
      out.EM.push({
        value: pload[p].mod,
        text: pload[p].mod,
        //text: pload[p].mod + " - " + pload[p].description,
      })
    }else if(pload[p].type == "CPT"){
      out.CPT.push({
        value: pload[p].mod,
        text: pload[p].mod,
        //text: pload[p].mod + " - " + pload[p].description,
      })
    }else{
      // console.log ("DIDN'T FIT: " + pload[p].type);
    }
  }
  return out;
}

const statusCleanerNew = function (payload, statusCols, facs) {
  // // console.log("SC: " + JSON.stringify(statusCols));
  // // console.log("FACS: " + JSON.stringify(facs));
  let plen = payload.length,
    //statusCols = this.getters.QueueStatusCols,
    sclen = statusCols.length,
    facilities = {},
    statusData = [],
    statuses = {},
    statlookup = {};

  for (let s = 0; s < sclen; s++) {
    statuses[statusCols[s].value] = 0;
    let statconcat = statusCols[s].status;
    statlookup[statconcat] = statusCols[s].value;
  }
  
  // // console.log("SL: " + JSON.stringify(statlookup));
  // // console.log("STATUSES: " + JSON.stringify(statuses));
  // // console.log("PLEN: " + plen);

  for (let p = 0; p < plen; p++) {
    let statconcat = payload[p].status,
      statval = statlookup[statconcat];
    if (facilities[payload[p].facility]) {
      facilities[payload[p].facility][statval] += 1;
    } else {
      facilities[payload[p].facility] = {
        client: payload[p].client,
        facility: payload[p].facility,
        client_display: facs[payload[p].facility].client_display_name,
        facility_display: facs[payload[p].facility].facility_display_name,
        ...statuses
      };
      facilities[payload[p].facility][statval] += 1;
    }
  }
  // // console.log(JSON.stringify(facilities));

  let fackeys = Object.keys(facilities),
    fklen = fackeys.length;
  for (let fk = 0; fk < fklen; fk++) {
    statusData.push(facilities[fackeys[fk]]);
  }
  // // console.log("SD: " + JSON.stringify(statusData));
  return statusData;
};

const statusCleaner = function (payload, statusCols) {
  let plen = payload.length,
    //statusCols = this.getters.QueueStatusCols,
    sclen = statusCols.length,
    facilities = {},
    statusData = [],
    statuses = {},
    statlookup = {},
    facNames = {
      "WMH":"Wayne Memorial Hospital",
      "Test_Fac":"Test Facility"
    },
    clientNames = {
      "NetMD":"NetMD",
      "Test_Client":"Test Client"
    };


  //let dlen = data.length;

  //// console.log("DATA: " + dlen);
  // TODO: iterate for multiple facilities/clients
  // for (let d = 0; d < dlen; d++) {
  //   //// console.log(data[d]);
  //   facNames[data[d].facility] = data[d].facility_display_name;
  //   clientNames[data[d].client] = data[d].client_display_name;
  // }

  //// console.log("FACNAMES: " + JSON.stringify(facNames));
  //// console.log("clientNames: " + JSON.stringify(clientNames));

  for (let s = 0; s < sclen; s++) {
    statuses[statusCols[s].value] = 0;
    let statconcat = statusCols[s].status + (statusCols[s].hold_status ? "_" + statusCols[s].hold_status : "");
    statlookup[statconcat] = statusCols[s].value;
  }
  //// console.log(JSON.stringify(statuses));
  //// console.log(JSON.stringify(statlookup));

  for (let p = 0; p < plen; p++) {
    let statconcat = payload[p].status + (payload[p].hold_status ? "_" + payload[p].hold_status : ""),
      statval = statlookup[statconcat];
    if (facilities[payload[p].facility]) {
      facilities[payload[p].facility][statval] += 1;
    } else {
      facilities[payload[p].facility] = {
        client: payload[p].client,
        facility: payload[p].facility,
        client_display: clientNames[payload[p].client],
        facility_display: facNames[payload[p].facility],
        ...statuses
      };
      facilities[payload[p].facility][statval] += 1;
    }
  }
  //// console.log(JSON.stringify(facilities));

  let fackeys = Object.keys(facilities),
    fklen = fackeys.length;
  for (let fk = 0; fk < fklen; fk++) {
    statusData.push(facilities[fackeys[fk]]);
  }
  //// console.log("SD: " + JSON.stringify(statusData));
  return statusData;
};

const getData = async function (url, oldjwt, data = {}) {
  const session = await Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
    //// console.log('jwt store',jwt);
  
    // Default options are marked with *
    const response = await fetch(url, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt,
      },
      referrerPolicy: 'no-referrer',
    });
    return response.json(); // parses JSON response into native JavaScript objects
};